import { HttpContextToken, HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { Observable, tap } from "rxjs";

// Se usa para poder meter en la request cosas que no llegan al backend sino que se usan en los filtros.
// En el contructor se mete funcion que devuelve valor por defecto, para las peticiones donde no se incluya
export const CACHING_ENABLED = new HttpContextToken<boolean>(() => true);
export function loggingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    console.log("Intercepcion en request hacia url: ", req.url);
    if (req.context.get(CACHING_ENABLED)) {
        // Cache habilitada
        console.log("Interceptor cache habilitado");
    } else {
        console.log("Interceptor cache deshabilitado");
    }
    // Esta es la forma de meter headers pero lo comento porque me lo tira el cors
    //const reqWithHeader = req.clone({
    //    headers: req.headers.set('mi-header', 'new header value'),
    //  });
   // return next(reqWithHeader).pipe(tap(event => {
    return next(req).pipe(tap(event => {
      if (event.type === HttpEventType.Response) {
        console.log("Intercepcion en response ", req.url, ' returned a response with status', event.status);
        console.log("Response body:", event.body);
      }
      
    }));
  }